import { Alert, Typography, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type ErrorAlertProps = {
  title: string;
  description?: string;
};

export const ErrorAlert = ({ title, description }: ErrorAlertProps) => {
  const theme = useTheme();
  console.log("theme.palette", theme);

  return (
    <Alert
      icon={<InfoOutlinedIcon sx={{ color: "error.main" }} />}
      severity="info"
      variant={"outlined"}
      sx={{
        backgroundColor: "error.light",
        borderColor: "error.main",
      }}
    >
      <Typography variant={"body1"} sx={{ color: "error.dark" }}>
        {title}
      </Typography>
      {description && (
        <Typography variant={"body2"} sx={{ color: "error.dark" }}>
          {description}
        </Typography>
      )}
    </Alert>
  );
};
